import { getEmployeeAbsencePermissionsConsult } from '../../shared/data-services/employee-services';
import { Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";

const BoldHeader = styled("span")({
    fontWeight: "bold"
});

export async function getMonthsView(strfechaInicio, strfechaFin) {
    const fechaInicio = new Date(strfechaInicio);
    const fechaFin = new Date(strfechaFin);
    const data = [];

    while (fechaFin >= fechaInicio) {
        const Month = new Intl.DateTimeFormat('es-CO', { month: "long" }).format(new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), 1));
        data.push({
            Year: fechaInicio.getFullYear(),
            Month: Month.charAt(0).toUpperCase() + Month.slice(1)
        });
        fechaInicio.setMonth(fechaInicio.getMonth() + 1);
    }
    return data;
};

export async function getData(params) {
    console.log(params);
    const data = await getEmployeeAbsencePermissionsConsult(params);
    console.log(data);
    return data.map((element, index) => {
        const start = element.startDate ? new Date(element.startDate) : null;
        const end = element.endDate ? new Date(element.endDate) : null;
        const daysBetween = (start && end)
            ? (() => {
                const startDateOnly = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                const endDateOnly = new Date(end.getFullYear(), end.getMonth(), end.getDate());
                const diff = Math.floor((endDateOnly.getTime() - startDateOnly.getTime()) / (1000 * 60 * 60 * 24));
                return diff >= 0 ? diff + 1 : "";
            })()
            : "";

        return {
            "id": element.employeeAbsencePermissionsId || index,
            "employeeId": element.employeeId,
            "employeeFullName": `${element.employeeFullName}`,
            "airportCode": element.code,
            "requirementType": getRequerimentTypeDescription(element.requirementType),
            "absenceTypeDescription": element.absenceTypeDescription,
            "absenceDescription": element.absenceDescription,
            "employeeArea": element.employeeArea,
            "startDate": element.startDate ? new Date(element.startDate).toISOString().split('T')[0] : "",
            "endDate": element.endDate ? new Date(element.endDate).toISOString().split('T')[0] : "",
            "daysBetween": daysBetween, // <-- Nueva propiedad
            "justify": element.justify || "",
            "response": element.response || "",
            "isVerified": element.isVerified ? "Verificado" : "No Verificado",
            "isActive": element.isActive ? "Activo" : "Inactivo",
            "createdDate": element.createdDate
                ? dayjs(element.createdDate).format('YYYY-MM-DD HH:mm')
                : "",
            "responseDate": element.responseDate
                ? dayjs(element.responseDate).format('YYYY-MM-DD HH:mm')
                : "",
            "responseEmployee": element.responseEmployee || ""
        }
    });
};

function getRequerimentTypeDescription(type) {
    switch (type) {
        case 1:
            return "Ausencia";
        case 2:
            return "Permiso";
        case 3:
            return "Cumpleaños";
        case 4:
            return "Día de la familia";
        default:
            return "Desconocido";
    }
}

export async function getDataExport(params) {
    const data = await getData(params);
    const dataReal = [];

    data.forEach(element => {
        const itemReal = [
            { v: element.employeeId, t: "s" },
            { v: element.employeeFullName, t: "s" },
            { v: element.airportCode, t: "s" },
            { v: element.requirementType, t: "s" },
            { v: element.absenceTypeDescription, t: "s" },
            { v: element.absenceDescription, t: "s" },
            { v: element.employeeArea, t: "s" },
            { v: element.startDate, t: "s" },
            { v: element.endDate, t: "s" },
            { v: element.daysBetween !== "" ? element.daysBetween.toString() : "", t: "s" }, // <-- Nuevo campo exportado
            { v: element.justify || "", t: "s" },
            { v: element.response || "", t: "s" },
            { v: element.isVerified, t: "s" },
            { v: element.isActive, t: "s" },
            { v: element.createdDate, t: "s" },
            { v: element.responseDate || "", t: "s" },
            { v: element.responseEmployee || "", t: "s" }
        ];
        dataReal.push(itemReal);
    });

    return dataReal;
};

export async function getColumns(dataShift) {
    return [
        {
            field: 'id',
            headerName: 'ID',
            width: 60,
            hide: true
        },
        {
            field: 'employeeId',
            headerName: 'Identificación',
            width: 150,
            renderHeader: () => <BoldHeader>Identificación</BoldHeader>
        },
        {
            field: 'employeeFullName',
            headerName: 'Nombre completo',
            width: 200,
            renderHeader: () => <BoldHeader>Nombre completo</BoldHeader>
        },
        {
            field: 'airportCode',
            headerName: 'Base',
            width: 70,
            renderHeader: () => <BoldHeader>Base</BoldHeader>
        },
        {
            field: 'requirementType',
            headerName: 'Tipo de Requisito',
            width: 150,
            renderHeader: () => <BoldHeader>Tipo de Requisito</BoldHeader>
        },
        {
            field: 'absenceTypeDescription',
            headerName: 'Tipo de Ausencia',
            width: 200,
            renderHeader: () => <BoldHeader>Tipo de Ausencia</BoldHeader>
        },
        {
            field: 'absenceDescription',
            headerName: 'Descripción de Ausencia',
            width: 250,
            renderHeader: () => <BoldHeader>Descripción de Ausencia</BoldHeader>
        },
        {
            field: 'employeeArea',
            headerName: 'Área del Empleado',
            width: 200,
            renderHeader: () => <BoldHeader>Área del Empleado</BoldHeader>
        },
        {
            field: 'startDate',
            headerName: 'Fecha Inicio',
            width: 150,
            renderHeader: () => <BoldHeader>Fecha Inicio</BoldHeader>
        },
        {
            field: 'endDate',
            headerName: 'Fecha Fin',
            width: 150,
            renderHeader: () => <BoldHeader>Fecha Fin</BoldHeader>
        },
        {
            field: 'daysBetween',
            headerName: 'Días entre Fechas',
            width: 80,
            renderHeader: () => <BoldHeader>Días</BoldHeader>
        },
        {
            field: 'justify',
            headerName: 'Justificación',
            width: 250,
            renderHeader: () => <BoldHeader>Justificación</BoldHeader>
        },
        {
            field: 'response',
            headerName: 'Respuesta',
            width: 250,
            renderHeader: () => <BoldHeader>Respuesta</BoldHeader>
        },
        {
            field: 'isVerified',
            headerName: 'Verificación',
            width: 120,
            renderHeader: () => <BoldHeader>Verificación</BoldHeader>
        },
        {
            field: 'isActive',
            headerName: 'Estado',
            width: 100,
            renderHeader: () => <BoldHeader>Estado</BoldHeader>
        },
        {
            field: 'createdDate',
            headerName: 'Fecha Creación',
            width: 150,
            renderHeader: () => <BoldHeader>Fecha Creación</BoldHeader>,
            valueGetter: (params) => params.value ? dayjs(params.value).format("YYYY-MM-DD HH:mm") : ''
        },
        {
            field: 'responseDate',
            headerName: 'Fecha Respuesta',
            width: 150,
            renderHeader: () => <BoldHeader>Fecha Respuesta</BoldHeader>,
            valueGetter: (params) => params.value ? dayjs(params.value).format("YYYY-MM-DD HH:mm") : ''
        },
        {
            field: 'responseEmployee',
            headerName: 'Empleado Respuesta',
            width: 165,
            renderHeader: () => <BoldHeader>Empleado Respuesta</BoldHeader>
        }
    ];
}
